// AdminHeader.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
//import logo from '/assets/logormv.png'; // Make sure you have a logo image in this path
//import logo from '../../public/assets/images/logormv.png';
const AdminHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="admin-header">
      <div className="admin-header-container">
        <div className="admin-logo">
          <Link to="/admin/dashboard">
          <img src="/assets/images/logormv.png" alt="Food Delivery Online" />
            {/* <img src={logo} alt="Food Delivery Online" /> */}
            <span>Admin Panel</span>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="admin-nav-desktop">
          <ul>
            <li><Link to="/admin/dashboard">Dashboard</Link></li>
            <li><Link to="/admin/users">Manage Users</Link></li>
            <li><Link to="/admin/restaurants">Manage Restaurants</Link></li>
            <li><Link to="/admin/food-items">Manage Food Items</Link></li>
            <li><Link to="/admin/orders">Orders</Link></li>
            <li><Link to="/admin/statistics">Statistics</Link></li>
            <li><Link to="/admin/messages">Contact Messages</Link></li>
          </ul>
        </nav>

        {/* Mobile Menu Button */}
        <div className="admin-mobile-menu-button" onClick={toggleMobileMenu}>
          <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Admin User Section */}
        <div className="admin-user">
          <div className="admin-avatar">
            <img src="/admin-avatar.png" alt="Admin" />
          </div>
          <div className="admin-dropdown">
            <span className="admin-name">Admin</span>
            <div className="admin-dropdown-content">
              <Link to="/admin/profile">Profile</Link>
              <Link to="/admin/settings">Settings</Link>
              <Link to="/admin/logout">Logout</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <nav className={`admin-nav-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul>
          <li><Link to="/admin/dashboard" onClick={toggleMobileMenu}>Dashboard</Link></li>
          <li><Link to="/admin/users" onClick={toggleMobileMenu}>Manage Users</Link></li>
          <li><Link to="/admin/restaurants" onClick={toggleMobileMenu}>Manage Restaurants</Link></li>
          <li><Link to="/admin/food-items" onClick={toggleMobileMenu}>Manage Food Items</Link></li>
          <li><Link to="/admin/orders" onClick={toggleMobileMenu}>Orders</Link></li>
          <li><Link to="/admin/statistics" onClick={toggleMobileMenu}>Statistics</Link></li>
          <li><Link to="/admin/messages" onClick={toggleMobileMenu}>Contact Messages</Link></li>
          <li className="mobile-only"><Link to="/admin/profile" onClick={toggleMobileMenu}>Profile</Link></li>
          <li className="mobile-only"><Link to="/admin/settings" onClick={toggleMobileMenu}>Settings</Link></li>
          <li className="mobile-only"><Link to="/admin/logout" onClick={toggleMobileMenu}>Logout</Link></li>
        </ul>
      </nav>

      <style jsx>{`
        .admin-header {
          background-color: #1a1c2e;
          color: white;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
        }

        .admin-header-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem 2rem;
          max-width: 1400px;
          margin: 0 auto;
        }

        .admin-logo {
          display: flex;
          align-items: center;
        }

        .admin-logo a {
          display: flex;
          align-items: center;
          text-decoration: none;
          color: white;
        }

        .admin-logo img {
          height: 40px;
          margin-right: 10px;
          animation: pulse 2s infinite;
        }

        .admin-logo span {
          font-size: 1.2rem;
          font-weight: bold;
          margin-left: 8px;
        }

        .admin-nav-desktop ul {
          display: flex;
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .admin-nav-desktop li {
          margin: 0 15px;
        }

        .admin-nav-desktop a {
          color: white;
          text-decoration: none;
          font-weight: 500;
          padding: 8px 0;
          position: relative;
          transition: all 0.3s ease;
        }

        .admin-nav-desktop a:hover {
          color: #ff6b6b;
        }

        .admin-nav-desktop a::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background-color: #ff6b6b;
          transition: width 0.3s ease;
        }

        .admin-nav-desktop a:hover::after {
          width: 100%;
        }

        .admin-user {
          display: flex;
          align-items: center;
          position: relative;
        }

        .admin-avatar {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
          border: 2px solid #ff6b6b;
        }

        .admin-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .admin-name {
          font-weight: 500;
          cursor: pointer;
        }

        .admin-dropdown {
          position: relative;
          cursor: pointer;
        }

        .admin-dropdown-content {
          display: none;
          position: absolute;
          right: 0;
          top: 100%;
          background: #fff;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          border-radius: 5px;
          min-width: 150px;
          z-index: 1001;
        }

        .admin-dropdown:hover .admin-dropdown-content {
          display: block;
        }

        .admin-dropdown-content a {
          display: block;
          padding: 10px 15px;
          color: #333;
          text-decoration: none;
          transition: background 0.3s;
        }

        .admin-dropdown-content a:hover {
          background: #f5f5f5;
          color: #ff6b6b;
        }

        .admin-mobile-menu-button {
          display: none;
          cursor: pointer;
        }

        .hamburger {
          width: 25px;
          height: 20px;
          position: relative;
        }

        .hamburger span {
          display: block;
          width: 100%;
          height: 2px;
          background: white;
          position: absolute;
          left: 0;
          transition: 0.3s;
        }

        .hamburger span:nth-child(1) {
          top: 0;
        }

        .hamburger span:nth-child(2) {
          top: 9px;
        }

        .hamburger span:nth-child(3) {
          top: 18px;
        }

        .hamburger.active span:nth-child(1) {
          transform: rotate(45deg);
          top: 9px;
        }

        .hamburger.active span:nth-child(2) {
          opacity: 0;
        }

        .hamburger.active span:nth-child(3) {
          transform: rotate(-45deg);
          top: 9px;
        }

        .admin-nav-mobile {
          display: none;
          background: #1a1c2e;
          padding: 0;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.5s ease;
        }

        .admin-nav-mobile.open {
          max-height: 500px;
          padding: 1rem 0;
        }

        .admin-nav-mobile ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .admin-nav-mobile li {
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .admin-nav-mobile a {
          display: block;
          padding: 15px 2rem;
          color: white;
          text-decoration: none;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .admin-nav-mobile a:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #ff6b6b;
        }

        .mobile-only {
          display: none;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        @media (max-width: 1024px) {
          .admin-nav-desktop {
            display: none;
          }

          .admin-mobile-menu-button {
            display: block;
          }

          .admin-nav-mobile {
            display: block;
          }

          .mobile-only {
            display: block;
          }

          .admin-header-container {
            padding: 0.75rem 1rem;
          }
        }
      `}</style>
    </header>
  );
};

export default AdminHeader;